import { GroupWork } from '@mui/icons-material'
import PhysicalExperienceUpsellingList from './PhysicalExperienceUpsellingList'
import PhysicalExperienceUpsellingEdit from './PhysicalExperienceUpsellingEdit'
import PhysicalExperienceUpsellingCreate from './PhysicalExperienceUpsellingCreate'

const physicalUpsellingIndex = {
  icon: GroupWork,
  list: PhysicalExperienceUpsellingList,
  edit: PhysicalExperienceUpsellingEdit,
  create: PhysicalExperienceUpsellingCreate,
}

export default physicalUpsellingIndex
